module.exports = __webpack_public_path__ + "img/767989_323437_B6C4EE_343C44-256px.68ffbca2.png";